export default {
    PtSelectMenu: {
        selected: '選択済み',
        deselect: '全ての選択を取り消す',
    },
};
